<template>
    <div>
        <base-header class="pb-1">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">História</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <card>
                <h2 slot="header" class="mb-0">História</h2>
                <h5 slot="header" class="mb-0">Pequeno resumo da memória e história do nosso Bolão que completa 48 anos</h5>
                <div class="row">
                    <div class="col-12">
                        
                        &nbsp;&nbsp; O <strong>Bolão 10</strong> tem esse nome devido o 10º bolão da copa do mundo ser administrado por Oswaldo Osorio, e hoje, já estamos na sua 12ª versão, com um novo sistema, ainda melhor e mais moderno!<br/><br/>
                        &nbsp;&nbsp; Ou seja, o bolão existe desde a copa do mundo de <strong>1978</strong>, na Argentina, isto é, exatamente <strong>48 anos</strong>!!!<br/><br/>
                        
                        <div class="row">
                            <div class="col-12 text-center">
                                <a target="_blank" href="/img/historia/hist01.jpg"><img border=0 width="250" src="/img/historia/hist01.jpg"></a>
                            </div>
                        </div><br/>
                        
                        &nbsp;&nbsp; Pelas fotos, pode ser visto como eram feitos esses bolões: manuscritos, máquina de escrever, as primeiras edições eletronicamente e agora tudo via sistema.<br/><br/>

                        <div class="row">
                            <div class="col-6 text-center">
                                <a target="_blank" href="/img/historia/hist02.jpg"><img border=0 width="250" src="/img/historia/hist02.jpg"></a>
                            </div>
                            <div class="col-6 text-center">
                                <a target="_blank" href="/img/historia/hist03.jpg"><img border=0 width="150" src="/img/historia/hist03.jpg"></a>
                            </div>
                        </div><br/>
                        
                        &nbsp;&nbsp; Para essa Copa do Mundo de 2026, assim como na Copa passada, avançamos muito mais: Um sistema moderno, com usabilidade e tudo de forma <strong>on-line</strong>, onde se poderá ter todas as informações de forma atualizada a cada evento ou gol marcado pelas Seleções durante a Copa do Mundo!!<br/><br/>
                        
                        &nbsp;&nbsp; Desde o seu início, nesses 48 anos, temos participantes assíduos, tais como: <strong>Oswaldo Osorio (DF), Oswalmar (RJ), Rodrigo (RJ), Chaim (RJ), José Carlos, André Luiz (RJ) e Ricardo André</strong>. Esses todos praticamente do Rio de Janeiro, onde o Bolão iniciou e também quando o seu administrador ainda morava na cidade e hoje residente na Capital Federal. Outros, também, apesar de não estarem desde o seu início, fiéis em muitos outros anos no bolão.<br/><br/>
                        
                        &nbsp;&nbsp; Apesar de estarmos no 12º bolão (Copa no Canadá, EUA e México), o nome ainda se manteve em homenagem ao 10º bolão completado, por isso essa denominação de <strong>BOLÃO 10 !!!</strong><br/><br/>
                        
                        <div class="row">
                            <div class="col-6 text-center">
                                <a target="_blank" href="/img/historia/hist04.jpg"><img border=0 width="250" src="/img/historia/hist04.jpg"></a>
                            </div>
                            <div class="col-6 text-center">
                                <a target="_blank" href="/img/historia/hist05.jpg"><img border=0 width="150" src="/img/historia/hist05.jpg"></a>
                            </div>
                        </div><br/>

                        &nbsp;&nbsp; Na última edição, tivemos <strong>94 apostadores</strong>!!! Entre amigos, colegas e familiares!! <br/>
                        <br/>
                        <div class="row">
                            <div class="col-4"></div>
                            <div class="col-4">
                                <TABLE border="1">
                                <TR>
                                    <TH style="text-align:center;">#</TH>
                                    <TH>Nome</TH>
                                    <TH style="text-align:center;">Pontuação</TH>
                                </TR>
                                <TR><TD><strong>1.</strong></TD><TD><strong>Deborah Munhoz</strong></TD><TD><strong>134 pts</strong></TD></TR>
                                <TR><TD><strong>2.</strong></TD><TD><strong>Thais Leal</strong></TD><TD><strong>129 pts</strong></TD></TR>
                                <TR><TD><strong>3.</strong></TD><TD><strong>Vânia Prisca</strong></TD><TD><strong>123 pts</strong></TD></TR>
                                <TR><TD><strong>4.</strong></TD><TD><strong>Brenno</strong></TD><TD><strong>118 pts</strong></TD></TR>
                                <TR><TD><strong>5.</strong></TD><TD><strong>Carina Beze</strong></TD><TD><strong>117 pts</strong></TD></TR>
                                <TR><TD><strong>6.</strong></TD><TD><strong>Marcelo El-Corab</strong></TD><TD><strong>116 pts</strong></TD></TR>
                                <TR><TD>7.</TD><TD>Marcelo Osorio</TD><TD>114 pts</TD></TR>
                                <TR><TD>8.</TD><TD>Fabiana Bicudo</TD><TD>111 pts</TD></TR>
                                <TR><TD>9.</TD><TD>Blaz & Petar Jovic</TD><TD>109 pts</TD></TR>
                                <TR><TD>10.</TD><TD>Bruno Ávila</TD><TD>109 pts</TD></TR>
                                <TR><TD>11.</TD><TD>Rafael Lima</TD><TD>109 pts</TD></TR>
                                <TR><TD>12.</TD><TD>Gorane</TD><TD>108 pts</TD></TR>
                                <TR><TD>13.</TD><TD>Marcos Osorio</TD><TD>108 pts</TD></TR>
                                <TR><TD>14.</TD><TD>Pedro Osorio</TD><TD>108 pts</TD></TR>
                                <TR><TD>15.</TD><TD>Oswaldo</TD><TD>107 pts</TD></TR>
                                <TR><TD>16.</TD><TD>André Fortuna</TD><TD>105 pts</TD></TR>
                                <TR><TD>17.</TD><TD>Lara Lunardi</TD><TD>105 pts</TD></TR>
                                <TR><TD>18.</TD><TD>Rodrigo Ruiz</TD><TD>105 pts</TD></TR>
                                <TR><TD>19.</TD><TD>Biroschel</TD><TD>104 pts</TD></TR>
                                <TR><TD>20.</TD><TD>Lucas Barros</TD><TD>104 pts</TD></TR>
                                <TR><TD>21.</TD><TD>Paulo Garrido</TD><TD>104 pts</TD></TR>
                                <TR><TD>22.</TD><TD>Felipe Gontijo</TD><TD>103 pts</TD></TR>
                                <TR><TD>23.</TD><TD>Salada</TD><TD>103 pts</TD></TR>
                                <TR><TD>24.</TD><TD>Marcus Rito</TD><TD>101 pts</TD></TR>
                                <TR><TD>25.</TD><TD>Miguel Lima</TD><TD>101 pts</TD></TR>
                                <TR><TD>26.</TD><TD>Teresinha</TD><TD>101 pts</TD></TR>
                                <TR><TD>27.</TD><TD>Antonio Avelar</TD><TD>100 pts</TD></TR>
                                <TR><TD>28.</TD><TD>Luana Sales</TD><TD>100 pts</TD></TR>
                                <TR><TD>29.</TD><TD>Mauro Leitão</TD><TD>100 pts</TD></TR>
                                <TR><TD>30.</TD><TD>João Osorio</TD><TD>99 pts</TD></TR>
                                <TR><TD>31.</TD><TD>Fernanda Natividade</TD><TD>98 pts</TD></TR>
                                <TR><TD>32.</TD><TD>Marcela Amorim</TD><TD>97 pts</TD></TR>
                                <TR><TD>33.</TD><TD>Naijaína Cardoso</TD><TD>97 pts</TD></TR>
                                <TR><TD>34.</TD><TD>Volmar</TD><TD>97 pts</TD></TR>
                                <TR><TD>35.</TD><TD>Lunardi</TD><TD>95 pts</TD></TR>
                                <TR><TD>36.</TD><TD>Livia Lunardi</TD><TD>93 pts</TD></TR>
                                <TR><TD>37.</TD><TD>Thiago Beze</TD><TD>93 pts</TD></TR>
                                <TR><TD>38.</TD><TD>Vitor Barroso</TD><TD>93 pts</TD></TR>
                                <TR><TD>39.</TD><TD>Bruno Reis</TD><TD>92 pts</TD></TR>
                                <TR><TD>40.</TD><TD>Inaldo Ferraz</TD><TD>92 pts</TD></TR>
                                <TR><TD>41.</TD><TD>Vanessa Fonseca</TD><TD>92 pts</TD></TR>
                                <TR><TD>42.</TD><TD>Leandro Pereira</TD><TD>91 pts</TD></TR>
                                <TR><TD>43.</TD><TD>Sérgio Passarella</TD><TD>90 pts</TD></TR>
                                <TR><TD>44.</TD><TD>Ednaldo Gonçalves</TD><TD>89 pts</TD></TR>
                                <TR><TD>45.</TD><TD>Beto</TD><TD>88 pts</TD></TR>
                                <TR><TD>46.</TD><TD>Rebeca Tonello</TD><TD>88 pts</TD></TR>
                                <TR><TD>47.</TD><TD>Daniel Rito</TD><TD>87 pts</TD></TR>
                                <TR><TD>48.</TD><TD>Jader Santana</TD><TD>87 pts</TD></TR>
                                <TR><TD>49.</TD><TD>Marina Godoy</TD><TD>87 pts</TD></TR>
                                <TR><TD>50.</TD><TD>Ricardo Osorio</TD><TD>87 pts</TD></TR>
                                <TR><TD>51.</TD><TD>Rodrigo Osorio</TD><TD>87 pts</TD></TR>
                                <TR><TD>52.</TD><TD>Simone Sampaio</TD><TD>87 pts</TD></TR>
                                <TR><TD>53.</TD><TD>Diana Loos</TD><TD>86 pts</TD></TR>
                                <TR><TD>54.</TD><TD>Fábio Cleto</TD><TD>86 pts</TD></TR>
                                <TR><TD>55.</TD><TD>Flávio Avalone</TD><TD>86 pts</TD></TR>
                                <TR><TD>56.</TD><TD>Isabel Viégas</TD><TD>86 pts</TD></TR>
                                <TR><TD>57.</TD><TD>Luka Jovic</TD><TD>86 pts</TD></TR>
                                <TR><TD>58.</TD><TD>Paula Bozzer</TD><TD>86 pts</TD></TR>
                                <TR><TD>59.</TD><TD>Wellington Mattos</TD><TD>86 pts</TD></TR>
                                <TR><TD>60.</TD><TD>Henrique Calderon</TD><TD>85 pts</TD></TR>
                                <TR><TD>61.</TD><TD>Bruno Souza</TD><TD>84 pts</TD></TR>
                                <TR><TD>62.</TD><TD>José Jorge</TD><TD>84 pts</TD></TR>
                                <TR><TD>63.</TD><TD>Luís Gabriel</TD><TD>84 pts</TD></TR>
                                <TR><TD>64.</TD><TD>Chain Mamed</TD><TD>83 pts</TD></TR>
                                <TR><TD>65.</TD><TD>Felipe Sousa</TD><TD>83 pts</TD></TR>
                                <TR><TD>66.</TD><TD>Gilberto Infra</TD><TD>82 pts</TD></TR>
                                <TR><TD>67.</TD><TD>Isabela Ribeiro</TD><TD>82 pts</TD></TR>
                                <TR><TD>68.</TD><TD>Denise Souza</TD><TD>81 pts</TD></TR>
                                <TR><TD>69.</TD><TD>Lucas Galo</TD><TD>81 pts</TD></TR>
                                <TR><TD>70.</TD><TD>Rafaela Barros</TD><TD>81 pts</TD></TR>
                                <TR><TD>71.</TD><TD>Thiago Saldanha</TD><TD>81 pts</TD></TR>
                                <TR><TD>72.</TD><TD>Erasmo Assunção</TD><TD>80 pts</TD></TR>
                                <TR><TD>73.</TD><TD>Ranielly</TD><TD>80 pts</TD></TR>
                                <TR><TD>74.</TD><TD>Santiago Magalhães</TD><TD>80 pts</TD></TR>
                                <TR><TD>75.</TD><TD>Bob</TD><TD>79 pts</TD></TR>
                                <TR><TD>76.</TD><TD>Masra Abreu</TD><TD>79 pts</TD></TR>
                                <TR><TD>77.</TD><TD>Cris Saemi</TD><TD>78 pts</TD></TR>
                                <TR><TD>78.</TD><TD>Arthur</TD><TD>76 pts</TD></TR>
                                <TR><TD>79.</TD><TD>Fernando Pereira</TD><TD>76 pts</TD></TR>
                                <TR><TD>80.</TD><TD>Rodrigo Rosa</TD><TD>74 pts</TD></TR>
                                <TR><TD>81.</TD><TD>Silvan Batista</TD><TD>74 pts</TD></TR>
                                <TR><TD>82.</TD><TD>Simone Reis</TD><TD>72 pts</TD></TR>
                                <TR><TD>83.</TD><TD>Andrézinho</TD><TD>71 pts</TD></TR>
                                <TR><TD>84.</TD><TD>Mariah El-Corab</TD><TD>71 pts</TD></TR>
                                <TR><TD>85.</TD><TD>Estela Maia</TD><TD>70 pts</TD></TR>
                                <TR><TD>86.</TD><TD>Jerônimo Natividade</TD><TD>66 pts</TD></TR>
                                <TR><TD>87.</TD><TD>Júlia Calderon</TD><TD>64 pts</TD></TR>
                                <TR><TD>88.</TD><TD>Raphael Bruno</TD><TD>62 pts</TD></TR>
                                <TR><TD>89.</TD><TD>Celso Rosa</TD><TD>61 pts</TD></TR>
                                <TR><TD>90.</TD><TD>Romeu</TD><TD>61 pts</TD></TR>
                                <TR><TD>91.</TD><TD>Daniel Peixoto</TD><TD>59 pts</TD></TR>
                                <TR><TD>92.</TD><TD>Cinthia Amorim</TD><TD>58 pts</TD></TR>
                                <TR><TD>93.</TD><TD>Paulo Amorim</TD><TD>58 pts</TD></TR>
                                <TR><TD>94.</TD><TD>Zé Carlos</TD><TD>58 pts</TD></TR>
                                </TABLE><br/>
                            </div>
                            <div class="col-4"></div>
                        </div>
                        <br/><br/>
                        
                        
                        &nbsp;&nbsp; Seja bem-vindo você também ao nosso Bolão!!!! E <strong>BOA SORTE</strong>!!!!<br/><br/>
                        
                    </div>
                </div>
            </card>
        </div> <!--- fecha conteudo -->

    </div>
</template>

<script>
export default {
    
}
</script>

<style>
</style>
